import { Flex, Image, Box } from '@chakra-ui/react';
import { tavoittajaLogo } from '@shared';
import { useState } from 'react';
import { IoCloseOutline, IoMenuOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router';
import MobileMenu from './SuperadminMobileMenu';

export function MobileHeader() {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
	const navigate = useNavigate();

	function handleMenuOpen(): void {
		setIsMobileMenuOpen(true);
	}

	function handleMenuClose(): void {
		setIsMobileMenuOpen(false);
	}

	return (
		<Flex zIndex={999} minHeight={'60px'} height={'60px'} width="100%" flexDirection={'column'}>
			<Flex
				alignItems={'center'}
				zIndex={999}
				justifyContent={'space-between'}
				width={'100%'}
				padding={2}
				height={'60px'}
				paddingLeft={4}
				paddingRight={5}
				backgroundColor={'rgba(61, 213, 152, 1)'}
			>
				<Image
					src={tavoittajaLogo}
					alt="Tavoittaja logo"
					height="40px"
					cursor="pointer"
					onClick={() => {
						navigate('/');
						handleMenuClose();
					}}
				/>
				{isMobileMenuOpen ? (
					<IoCloseOutline onClick={handleMenuClose} cursor={'pointer'} size={40} color="white" />
				) : (
					<IoMenuOutline onClick={handleMenuOpen} cursor={'pointer'} size={40} color="white" />
				)}
			</Flex>

			{isMobileMenuOpen ? <Backdrop handleMenuClose={handleMenuClose} /> : null}
			<MobileMenu isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
		</Flex>
	);
}

function Backdrop({ handleMenuClose }: { handleMenuClose: () => void }) {
	return <Box position="absolute" backgroundColor="blackAlpha.500" width="100vw" height="100vh" onClick={handleMenuClose}></Box>;
}
